<template>
  <div>
    <a-tabs v-model:activeKey="active_tab_key">
      <a-tab-pane v-for="tab in tabs" :key="tab.key" :tab="tab.title" />
    </a-tabs>
  </div>

  <router-view :key="$route.path"></router-view>
</template>

<script>
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default {
  name: 'TabsAll',
  setup() {
    // * route y router
    const route = useRoute();
    const router = useRouter();

    // * Tabs
    const active_tab_key = ref('');
    const tabs = [
      {
        title: 'Grupos',
        name: 'Grupos',
        key: '1'
      },
      {
        title: 'Póliza',
        name: 'Poliza',
        key: '2'
      },
      {
        title: 'Stock',
        name: 'Stock',
        key: '3'
      },
      {
        title: 'Usuarios',
        name: 'Usuarios',
        key: '4'
      },
      {
        title: 'Recepción',
        name: 'Recepcion',
        key: '5'
      },
      {
        title: 'Notificaciones',
        name: 'Notificaciones',
        key: '6'
      },
      {
        title: 'Brokers',
        name: 'Brokers',
        key: '7'
      },
      {
        title: 'Emails',
        name: 'Emails',
        key: '8'
      }
    ];

    const isCompanyRoute = () => {
      return route.matched.some((matchedRoute) => matchedRoute.name === 'Empresa');
    };

    const isCompanyTabRoute = () => {
      return tabs.some((tab) =>
        route.matched.some((matchedRoute) => matchedRoute.name === tab.name)
      );
    };

    watch(
      () => route.matched,
      () => {
        if (!isCompanyRoute()) {
          return;
        }

        const tabNames = route.matched.map((r) => r.name);
        const matchedTab = tabs.find((tab) => tabNames.includes(tab.name));
        if (!matchedTab) {
          active_tab_key.value = tabs[0].key;
          return;
        }

        active_tab_key.value = matchedTab.key;
      },
      { immediate: true, deep: true }
    );

    watch(active_tab_key, async (value) => {
      if (!isCompanyRoute() || !isCompanyTabRoute()) {
        return;
      }

      const target = tabs.find((obj) => obj.key === value);
      if (!target) return;

      const tabNames = route.matched.map((r) => r.name);
      if (tabNames.includes(target.name)) return;

      const allowedQueryByTab = {
        Poliza: route.query
      };

      await router.push({
        name: target.name,
        params: { id: route.params.id },
        query: allowedQueryByTab[target.name] || {},
        hash: ''
      });
    });

    return {
      active_tab_key,
      tabs
    };
  }
};
</script>
